import React from 'react'
import { Link } from 'gatsby'
import { ArrowRight } from '~/icons/ArrowRight'
import { Download } from '~/icons/Download'
import {cn} from "~/utils/classnames";

type InnerContentProps = {
  text: string;
  icon: 'arrow' | 'dl';
  reversed?: boolean | undefined;
  disabled?: boolean | undefined;
}


const InnerContent = ({ text, icon, reversed = false, disabled = false }: InnerContentProps) => {
  const IconComponent = icon === 'arrow' ? ArrowRight : Download
  return (
    <>
      <span
        className={`button-arrow__icon ${icon === 'dl' ? 'button-arrow__icon--dl' : ''} button-arrow__icon--left ${disabled ? 'border-[#a2a2a2]' : ''}`}
      >
        <IconComponent className={cn(disabled ? 'fill-[#a2a2a2]' : 'fill-white')} />
      </span>
      <span className={`button-arrow__txt ${reversed ? 'reversed' : ''}`}>{text}</span>
      <span
        className={`button-arrow__icon ${icon === 'dl' ? 'button-arrow__icon--dl' : ''} button-arrow__icon--right ${disabled ? 'border-[#a2a2a2]' : ''}`}
      >
        <IconComponent className={cn(disabled ? 'fill-[#a2a2a2]' : 'fill-white')} />
      </span>
    </>
  )
}

const InternalLink = ({ text, color, link, state, icon, contentType }) => {
  return (
    <>
      {contentType === 'ContentfulSimulator' ||
      contentType === 'ContentfulContact' ? (
        <a
          href={link}
          state={state}
          className={`button-arrow bg-${color}`}
          aria-label={'internal-link'}
        >
          <InnerContent text={text} icon={icon} />
        </a>
      ) : (
        <Link to={link} state={state} className={`button-arrow bg-${color}`}>
          <InnerContent text={text} icon={icon} />
        </Link>
      )}
    </>
  )
}

const ExternalLink = ({ text, color, link, icon }) => {
  return (
    <a
      href={link}
      className={`button-arrow bg-${color}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="external-link"
    >
      <InnerContent text={text} icon={icon} />
    </a>
  )
}

type ButtonProps = {
  text: string;
  color: string;
  action: () => void;
  icon: 'arrow' | 'dl';
  type?: "submit" | "reset" | "button" | undefined;
  reversed?: boolean | undefined;
  disabled?: boolean | undefined;
}

const Button = ({ text, color, action, icon, type, reversed = false, disabled = false }: ButtonProps) => {
  return (
    <button
      className={`button-arrow bg-${color} ${reversed ? 'rotate-180' : ''} ${disabled ? '!bg-[#f9f9f9] !text-[#a2a2a2] pointer-events-none' : ''}`}
      onClick={action}
      aria-label={text}
      type={type}
      disabled={disabled}
    >
      <InnerContent text={text} icon={icon} reversed={reversed} disabled={disabled} />
    </button>
  )
}


type ButtonArrowProps = {
  text: string;
  color: string;
  action: () => void;
  icon?: 'arrow' | 'dl';
  link?: string;
  external?: boolean;
  contentType?: boolean;
  state?: any;
  type?: "submit" | "reset" | "button" | undefined;
  reversed?: boolean | undefined;
  disabled?: boolean | undefined;
}

const buttonArrow = ({
  text,
  link,
  color,
  external,
  action,
  state,
  icon = 'arrow',
  contentType = false,
  type,
  reversed = false,
  disabled = false,
}: ButtonArrowProps) => {
  let button

  const http = new RegExp('^(http|https)://', 'i')
  const assets = new RegExp('^//assets.ctfassets', 'i')
  const assets2 = new RegExp('^//downloads.ctfassets', 'i')

  if (link && (link.match(http) || link.match(assets) || link.match(assets2))) {
    external = true
  }

  if (link) {
    if (external) {
      button = (
        <ExternalLink text={text} color={color} link={link} icon={icon} />
      )
    } else {
      button = (
        <InternalLink
          text={text}
          color={color}
          link={link}
          state={state}
          icon={icon}
          contentType={contentType}
        />
      )
    }
  } else {
    button = <Button text={text} type={type} color={color} action={action} icon={icon} reversed={reversed} disabled={disabled} />
  }

  return <>{button}</>
}

export default buttonArrow
